export default "__VITE_ASSET__CSViT8jI__"